( function ($){

    $ (document).ready (function ($){
        var swiper = new Swiper ('.logos-widget .swiper-container', {
            // Optional parameters
            loop: true,
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: -1,
            speed: 600,
            autoplay: {
                delay: 3000,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            breakpoints: {

                // when window width is >= SM
                576: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                // when window width is >= MD
                768: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,

                },
                // when window width is >= XL
                1200: {
                    slidesPerView: 6,
                    slidesPerGroup: 6,

                }
            }

        });

        $ ('.logos-widget .swiper-container').on ('mouseenter', function (e){
            swiper.autoplay.stop ()
        })
        $ ('.logos-widget .swiper-container').on ('mouseleave', function (e){
            swiper.autoplay.start ()
        })

    });

} ) (jQuery);
